module.exports = __webpack_public_path__ + "img/book5.a7fba513.jpg";